import { render, staticRenderFns } from "./veicoli.vue?vue&type=template&id=3654fefa"
import script from "./veicoli.vue?vue&type=script&lang=js"
export * from "./veicoli.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports